/* eslint-disable */
import { defineAsyncComponent } from 'vue';

export const registerComponents = app => {
  app.component('modal', require('@views/components/Modals/Modal.vue').default);
  app.component('modal-confirm', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Modals/ModalConfirm.vue'
    ))
  );
  app.component('s-datepicker', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Form/Datepicker.vue'
    ))
  );
  app.component('s-text-input', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Form/TextInput.vue'
    ))
  );
  app.component('s-textarea', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Form/Textarea.vue'
    ))
  );
  app.component('s-select-input', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Form/SelectInput.vue'
    ))
  );
  app.component('s-password-indicator', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Form/PasswordIndicator.vue'
    ))
  );
  app.component('s-tooltip', defineAsyncComponent(() =>
    import(/* webpackChunkName: "components" */ '@views/components/Form/Tooltip.vue'))
  );
  app.component('float-content', defineAsyncComponent(() =>
    import(/* webpackChunkName: "components" */ '@views/components/FloatContent'))
  );

  // Buttons
  app.component('s-button', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Buttons/Button.vue'
    ))
  );
  app.component('ButtonHome', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Buttons/ButtonHome.vue'
    ))
  );
  app.component('ButtonBack', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Buttons/ButtonBack.vue'
    ))
  );
  app.component('ButtonBackOrHome', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Buttons/ButtonBackOrHome.vue'
    ))
  );
  app.component('ButtonToggleAutoScroll', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Buttons/ButtonToggleAutoScroll.vue'
    ))
  );
  app.component('ButtonTfaRequired', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Buttons/ButtonTfaRequired.vue'
    ))
  );

  app.component('CardContainer', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Cards/CardContainer.vue'
    ))
  );
  app.component('Card', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Cards/Card.vue'
    ))
  );

  app.component('CardScroll', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/Cards/CardScroll.vue'
    ))
  );

  app.component('s-right-arrow', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@views/components/SVG/RightArrow.vue'
    ))
  );

  app.component('symptoms-quincy', defineAsyncComponent(() =>
    import(
      /* webpackChunkName: "components" */ '@/Modules/quincy/src/Quincy/Quincy.vue'
    ))
  );

  app.component('content-placeholder', defineAsyncComponent(() =>
    import(/* webpackChunkName: "components" */ '@views/components/ContentPlaceholder/ContentPlaceholder.vue'
    ))
  );

  app.component('mask-container', defineAsyncComponent(() =>
    import(/* webpackChunkName: "components" */ '@views/components/ContentPlaceholder/MaskContainer.vue'
    ))
  );

  app.component('content-mask', defineAsyncComponent(() =>
    import(/* webpackChunkName: "components" */ '@views/components/ContentPlaceholder/Mask.vue'
    ))
  );

  app.component('flex-grid', defineAsyncComponent(() =>
    import(/* webpackChunkName: "components" */ '@views/components/Grids/FlexGrid.vue'
    ))
  );

  app.component('Errors', defineAsyncComponent(() =>
    import(/* webpackChunkName: "components" */ '@views/components/Errors.vue'))
  );
};
